import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/layout/PageHeader';
import { PricingTiers } from '../components/pricing/PricingTiers';
import { CtaBand } from '../components/ui/CtaBand';
import { FaqList } from '../components/ui/FaqList';
import { SectionHeading } from '../components/ui/SectionHeading';
import { faqs } from '../data/site';
import { programs } from '../data/programs';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { useBrand } from '../contexts/BrandContext';
export function Pricing() {
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: `Pricing — ${brand.name}`,
    description: 'Membership from $39/mo, medication priced separately and published up front. Your rate is held for twelve months.'
  });
  return <main data-id="element-432" data-mp="1fhwj07exk035">
      <PageHeader eyebrow="Pricing" title="Published rates, held for twelve months." intro="Clinical care and medication are priced separately so you can see exactly what you are paying for. No dispensing fees, no per-message charges." data-id="element-433" data-mp="1fglgsc14v0e5" />

      <section className="bg-cream" data-id="element-434" data-mp="1jkrr1py5z5w4">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-8 md:px-8 md:pb-28" data-id="element-435" data-mp="1jlt2hvj3dued">
          <PricingTiers data-id="element-436" data-mp="14ok80syhsaif" />
        </div>
      </section>

      <section className="bg-cream-light" data-id="element-437" data-mp="14q51ef92lnep">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-438" data-mp="19m27lsqmdddr">
          <SectionHeading eyebrow="Program rates" title="What each program costs on top of membership." intro="Medication pricing reflects what the pharmacy charges plus a fixed handling rate we publish. It does not change with your dose." data-id="element-439" data-mp="1xcprlcdt7tgo" />
          <table className="mt-12 w-full text-left" data-id="element-440" data-mp="1slpvuagffhfr">
            <caption className="sr-only" data-id="element-441" data-mp="1skera8f5q5nl">Monthly medication cost by {brand.name} program</caption>
            <thead data-id="element-442" data-mp="2gaikrmymsp0v">
              <tr className="rule text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-443" data-mp="2g9zdd06lxj13">
                <th scope="col" className="py-3 font-normal" data-id="element-444" data-mp="2l3boc7id5rbd">
                  Program
                </th>
                <th scope="col" className="hidden py-3 font-normal sm:table-cell" data-id="element-445" data-mp="2uvwpgehf14sa">
                  Category
                </th>
                <th scope="col" className="py-3 text-right font-normal" data-id="element-446" data-mp="2lx2ko0txl83n">
                  From
                </th>
              </tr>
            </thead>
            <tbody data-id="element-447" data-mp="2gxq2hte08p7e">
              {programs.map(program => <tr key={program.slug} className="rule" data-id="element-448" data-mp="2bzeod6gofsjd">
                  <th scope="row" className="py-5 pr-6 font-serif text-xl font-normal text-ink md:text-2xl" data-id="element-449" data-mp="2c0zm14yafrlg">
                    {program.name}
                  </th>
                  <td className="hidden py-5 text-sm text-ink-muted sm:table-cell" data-id="element-450" data-mp="229v53zp1xwnz">
                    {program.category}
                  </td>
                  <td className="py-5 text-right font-serif text-xl text-ink md:text-2xl" data-id="element-451" data-mp="1t8ngyag92c7m">
                    ${program.priceFrom}
                    <span className="ml-2 font-sans text-xs text-ink-muted" data-id="element-452" data-mp="1oalpb14rd4kj">/mo</span>
                  </td>
                </tr>)}
            </tbody>
          </table>
          <p className="mt-8 max-w-2xl text-sm leading-relaxed text-ink-muted" data-id="element-453" data-mp="8q38yxlg4l1t">
            Prices shown are the starting monthly cost for the medication component and assume an
            active membership. HSA and FSA documentation is provided for every charge.
          </p>
          <Link to="/shop" className="mt-6 inline-flex border-b border-brick pb-1 text-sm text-brick transition-colors duration-150 ease-republic hover:border-ink hover:text-ink" data-id="element-454" data-mp="3h6elq92fwaqs">
            See per-medication pricing in the pharmacy
          </Link>
        </div>
      </section>

      <section className="bg-cream" data-id="element-455" data-mp="3uycm9vi34ybc">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-456" data-mp="3uzdyi3au7qun">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-457" data-mp="2ygq41hnlmqtd">
            <SectionHeading eyebrow="Questions" title="Answered plainly." data-id="element-458" data-mp="32ha34qrqg4i5" />
            <FaqList items={faqs} data-id="element-459" data-mp="32f5md88qjb0g" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-460" data-mp="2jd6kp89sfbjp" />
    </main>;
}